import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import EditFormDefinitionPage from './EditFormDefinitionPage';
import FormDefinitionTabState from './FormDefinitionTabState';

export default class FormDefinitionTabView extends BufferTabView<FormDefinitionTabState> {
  render(): this {
    const props = {
      formDefinitionId: this.model.get('formDefinitionId'),
    };
    renderToDOM(<EditFormDefinitionPage {...props} />, this.el);
    return this;
  }

  remove(): Backbone.View<FormDefinitionTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

FormDefinitionTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
